import { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import mammoth from 'mammoth/mammoth.browser';
import ExcelJS from 'exceljs';
import download from "../../assets/images/download.svg";
import './FilePreviewModal.css';
import { toast } from 'react-toastify';
import LoaderComponent from '../LoaderComponent/LoaderComponent';
import { FaChevronLeft, FaChevronRight, FaSearchPlus } from 'react-icons/fa';
import * as pdfjsLib from 'pdfjs-dist'; // You already have this
import { useRef } from 'react'; // Add this if not already imported
import headphones from '../../assets/images/headphones.svg';

pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

export default function FilePreviewModal({
  isOpen,
  files,
  initialIndex = 0,
  onClose,
  getFileIcon
}) {
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [previewFile, setPreviewFile] = useState(null);
  const [textContent, setTextContent] = useState('');
  const [isLoadingPreview, setIsLoadingPreview] = useState(false);
  const [zoomLevel, setZoomLevel] = useState(1);
  // const [isZoomExpanded, setIsZoomExpanded] = useState(false);
  // const [isZoomExpanded, setIsZoomExpanded] = useState(false);

// const [pdfDoc, setPdfDoc] = useState(null);
// const [pdfPageNum, setPdfPageNum] = useState(1);
// const [pdfNumPages, setPdfNumPages] = useState(0);
// const [pdfScale, setPdfScale] = useState(1);
// const canvasRef = useRef(null);
// const [pdfDoc, setPdfDoc] = useState(null);
// const [pdfPageNum, setPdfPageNum] = useState(1);
// const [pdfNumPages, setPdfNumPages] = useState(0);
// const [pdfScale, setPdfScale] = useState(1);
// const canvasRef = useRef(null);

    // const zoomIn = () => {
    //   setZoomLevel((prevZoom) => Math.min(prevZoom + 0.1, 3));
    // };
    // const zoomIn = () => {
    //   setZoomLevel((prevZoom) => Math.min(prevZoom + 0.1, 3));
    // };

    // const zoomOut = () => {
    //   const newZoom = Math.max(zoomLevel - 0.1, 0.5);
    //   setZoomLevel(newZoom);
    //   if (Math.round(newZoom * 100) === 100) {
    //     setTimeout(() => setIsZoomExpanded(false), 300);
    //   }
    // };

const getFileTypeFromName = (filename) => {
    if (!filename) return '';
    
    const extension = filename.split('.').pop().toLowerCase();
    
    // Map extensions to MIME types
    const typeMap = {
      // Images
      'png': 'image/png',
      'jpg': 'image/jpeg',
      'jpeg': 'image/jpeg',
      'gif': 'image/gif',
      'bmp': 'image/bmp',
      'webp': 'image/webp',
      'svg': 'image/svg+xml',
      'heic': 'image/heic',
      
      // Documents
      'pdf': 'application/pdf',
      'doc': 'application/msword',
      'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'txt': 'text/plain',
      
      // Spreadsheets
      'xls': 'application/vnd.ms-excel',
      'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'csv': 'text/csv',
      
      // Audio
      'mp3': 'audio/mpeg',
      'wav': 'audio/wav',
      'ogg': 'audio/ogg',
      'm4a': 'audio/mp4',
      'webm': 'audio/webm',  
      
      // Archives
      'zip': 'application/zip',
      'rar': 'application/x-rar-compressed',
      '7z': 'application/x-7z-compressed',
    };
    
    return typeMap[extension] || 'application/octet-stream';
  };

  // The Office / Google viewers fetch the file from their own servers, so they can
  // only read publicly reachable http(s) URLs. A file that only exists locally (a
  // just-picked upload) has a `blob:`/`data:` URL — handing that to the viewer
  // renders a 404, so those are previewed in-browser instead.
  // Only the `blob:` *scheme* counts here: a hosted link that merely contains the
  // word "blob" (e.g. *.blob.core.windows.net) is a normal remote URL.
  const isLocalUrl = (url) => {
    if (!url) return true;
    return /^(blob:|data:)/i.test(url) || !/^https?:\/\//i.test(url);
  };


  // Add backdrop to body when modal opens
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  // Update current file when index changes
  useEffect(() => {
    if (isOpen && files && files.length > 0 && currentIndex < files.length) {
      loadFilePreview(files[currentIndex]);
    }
  }, [isOpen, currentIndex, files]);

  // Reset to initial index when modal opens
  useEffect(() => {
    if (isOpen) {
      setCurrentIndex(initialIndex);
    }
  }, [isOpen, initialIndex]);

  // Render PDF page when doc/page/scale changes
// useEffect(() => {
//   if (!pdfDoc || !canvasRef.current || previewFile?.type !== 'application/pdf') return;

//   const renderPage = async () => {
//     try {
//       const page = await pdfDoc.getPage(pdfPageNum);
//       const canvas = canvasRef.current;
//       const context = canvas.getContext('2d');

//       const viewport = page.getViewport({ scale: pdfScale });

//       canvas.width = viewport.width;
//       canvas.height = viewport.height;

//       const renderContext = {
//         canvasContext: context,
//         viewport: viewport,
//       };

//       await page.render(renderContext).promise;
//     } catch (error) {
//       console.error('Error rendering PDF page:', error);
//     }
//   };

//   renderPage();
// }, [pdfDoc, pdfPageNum, pdfScale, previewFile]);

// Helper: render an ExcelJS worksheet as a safe HTML table (replacement for
// the previous `XLSX.utils.sheet_to_html` call which came from the vulnerable
// `xlsx` package). Cell values are HTML-escaped to prevent XSS.
const escapeHtml = (str) =>
  String(str).replace(/[&<>"']/g, (m) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
  }[m]));

const cellToString = (val) => {
  if (val === null || val === undefined) return '';
  if (val instanceof Date) return val.toISOString();
  if (typeof val === 'object') {
    if (val.richText && Array.isArray(val.richText)) {
      return val.richText.map((r) => r.text || '').join('');
    }
    if (val.text !== undefined) return String(val.text);
    if (val.result !== undefined) return String(val.result);
    return JSON.stringify(val);
  }
  return String(val);
};

const worksheetToHtml = (worksheet) => {
  let html = '<table style="border-collapse: collapse; min-width: max-content;">';
  worksheet.eachRow({ includeEmpty: true }, (row) => {
    html += '<tr>';
    row.eachCell({ includeEmpty: true }, (cell) => {
      html += `<td style="border: 1px solid #ddd; padding: 4px;">${escapeHtml(cellToString(cell.value))}</td>`;
    });
    html += '</tr>';
  });
  html += '</table>';
  return html;
};

  const loadFilePreview = async (file) => {

    // Infer type from filename if not provided
    const inferredType = file.type || getFileTypeFromName(file.name);
    const fileWithType = { ...file, type: inferredType };
    setPreviewFile(fileWithType);
    setIsLoadingPreview(true);
    setTextContent('');

    try {

       if (!file.url) {
      console.error('No URL provided for file');
      setIsLoadingPreview(false);
      return;
    }

     if (inferredType.startsWith('image/')) {
      return;
    }

      // Handle text files
      // if (inferredType  === 'text/plain') {
      //   const reader = new FileReader();
      //   reader.onload = (e) => {
      //     setTextContent(e.target.result);
      //     setIsLoadingPreview(false);
      //   };
      //   reader.readAsText(file.file);
      // }

        // Handle text files
    if (inferredType === 'text/plain') {
      const response = await fetch(file.url);
      const text = await response.text();
      setTextContent(text);
      setIsLoadingPreview(false);
    }
    // Handle PDF files
else if (inferredType === 'application/pdf' || file.name?.endsWith('.pdf')) {
  // try {
  //   setPdfScale(1);
  //   const loadingTask = pdfjsLib.getDocument(file.url);
  //   const pdf = await loadingTask.promise;
  //   setPdfDoc(pdf);
  //   setPdfNumPages(pdf.numPages);
  //   setPdfPageNum(1); // Reset to first page
  //   setIsLoadingPreview(false);
  // } catch (error) {
  //   console.error('Error loading PDF:', error);
    setIsLoadingPreview(false);
  // }
}

      // Handle DOCX files
      else if (
        inferredType  === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
        file.name?.endsWith('.docx') ||
        file.name?.endsWith('.doc')
      ) {
           const response = await fetch(file.url);
        const arrayBuffer = await response.arrayBuffer();
        const result = await mammoth.convertToHtml({ arrayBuffer });
        setTextContent(result.value);
        setIsLoadingPreview(false);
      }
      // Handle Excel files
      else if (
        inferredType  === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
        inferredType  === 'application/vnd.ms-excel' ||
        file.name.endsWith('.xlsx') ||
        file.name.endsWith('.xls')
      ) {
        const response = await fetch(file.url);
        const arrayBuffer = await response.arrayBuffer();
        // Security: migrated from `xlsx` to `exceljs` (XSS-safe, no known CVEs).
        const workbook = new ExcelJS.Workbook();
        await workbook.xlsx.load(arrayBuffer);
        const firstSheet = workbook.worksheets[0];
        const htmlContent = firstSheet ? worksheetToHtml(firstSheet) : '';
        setTextContent(htmlContent);
        setIsLoadingPreview(false);
      }
      // Handle CSV files
      else if (inferredType  === 'text/csv' || file.name.endsWith('.csv')) {
        const response = await fetch(file.url);
        const text = await response.text();
        const rows = text.split('\n').map(row => row.split(','));
        const htmlTable = `
          <table style="border-collapse: collapse; width: 100%;">
            ${rows.map((row, i) => `
              <tr style="border-bottom: 1px solid #ddd;">
                ${row.map(cell => `
                  <td style="padding: 8px; border: 1px solid #ddd; ${i === 0 ? 'font-weight: bold; background-color: #f3f4f6;' : ''}">
                    ${cell.trim()}
                  </td>
                `).join('')}
              </tr>
            `).join('')}
          </table>
        `;
        setTextContent(htmlTable);
        setIsLoadingPreview(false);
      }
      else {
        setIsLoadingPreview(false);
      }
    } catch (error) {
      console.error('Error loading preview:', error);
      setTextContent('');
      setIsLoadingPreview(false);
    }
  };

  const handlePrevious = (e) => {
    e.stopPropagation();
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const handleNext = (e) => {
    e.stopPropagation();
    if (currentIndex < files.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handleClose = () => {
    setTextContent('');
    setPreviewFile(null);
    setZoomLevel(1);
    // setIsZoomExpanded(false);
    // setPdfDoc(null);
    // setPdfPageNum(1);
    // setPdfNumPages(0);
    // setPdfScale(1);
    onClose();
  };

  if (!isOpen || !previewFile) return null;

  const XIcon = () => (
    <svg style={{ width: '100%', height: '100%' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
    </svg>
  );

  const MusicIcon = () => (
    <img src={headphones} alt="MUSIC" width={"10%"} />
  );

  const FileIcon = () => (
    <svg style={{ width: '20px', height: '20px', color: '#6c757d' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
    </svg>
  );

  // Fallback when nothing can be previewed - keeps the download path available.
  const renderUnsupportedFallback = () => (
    <div style={{ padding: '40px', textAlign: 'center' }}>
      <FileIcon />
      <h3 style={{ margin: '20px 0 10px' }}>{previewFile.name}</h3>
      <p style={{ color: '#666' }}>Preview not available for this file type</p>
      <a
        href={previewFile.url}
        download={previewFile.name}
        style={{
          display: 'inline-block',
          marginTop: '20px',
          padding: '10px 20px',
          backgroundColor: '#0068FF',
          color: 'white',
          textDecoration: 'none',
          borderRadius: '6px'
        }}
      >
        Download File
      </a>
    </div>
  );

  // Renders the HTML that loadFilePreview already produced locally with mammoth
  // (docx) / ExcelJS (xlsx, csv), for blob-backed files the external viewers
  // cannot fetch.
  const renderLocalHtml = () => {
    if (!textContent) {
      return isLoadingPreview ? null : renderUnsupportedFallback();
    }
    return (
      <div style={{ padding: '20px', maxHeight: '70vh', overflow: 'auto', width: '100%',
            transform: `scale(${zoomLevel})`,
            transformOrigin: 'top left',
            transition: 'transform 0.2s ease' }}>
        <div
          dangerouslySetInnerHTML={{ __html: textContent }}
          style={{
            lineHeight: '1.6',
            fontFamily: 'system-ui, -apple-system, sans-serif'
          }}
        />
      </div>
    );
  };

  const renderPreviewContent = () => {
    if (!previewFile) {
    return null;
  }
  console.log(previewFile,'previewFile')
  const { type, name, url } = previewFile;  // Destructure to ensure correct file properties
    // Image files
    if (type.startsWith('image/')) {
       if (name.endsWith('.heic') || type === 'image/heic') {}
      return (
        <img 
          src={url} 
          alt={name}
          style={{ maxWidth: '100%', maxHeight: '70vh', objectFit: 'contain',  transform: `scale(${zoomLevel})`,
              transformOrigin: 'center',
              transition: 'transform 0.2s ease', }}
          onLoad={() => setIsLoadingPreview(false)}
        />
      );
    }
    
    // DOCX files
    if (
      type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
      name.endsWith('.docx') 
    ) {
      const previewUrl = previewFile?.serverUrl || previewFile?.url;
      if (isLocalUrl(previewUrl)) {
        return renderLocalHtml();
      }
      return (
        <iframe
                  src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
                    previewUrl,
                  )}`}
                  className="w-full h-full  border-0"
                  title={previewFile.name}
                />
        // <div style={{ padding: '20px', maxHeight: '70vh', overflow: 'auto', width: '100%', lineHeight: '1.6',
        //       transform: `scale(${zoomLevel})`,
        //       transformOrigin: 'top left',
        //       transition: 'transform 0.2s ease' }}>
        //   <div 
        //     dangerouslySetInnerHTML={{ __html: textContent }}
        //     style={{ 
        //       lineHeight: '1.6',
        //       fontFamily: 'system-ui, -apple-system, sans-serif'
        //     }}
        //   />
        // </div>
      );
    }

    // Excel/CSV files
    if (
      previewFile.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
      previewFile.type === 'application/vnd.ms-excel' ||
      previewFile.type === 'text/csv' ||
      previewFile.name.endsWith('.xlsx') ||
      previewFile.name.endsWith('.xls') ||
      previewFile.name.endsWith('.csv')
    ) {
      const previewUrl =  previewFile?.serverUrl || previewFile?.url;
      if (isLocalUrl(previewUrl)) {
        return renderLocalHtml();
      }
      return (
         <iframe
                  src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
                    previewUrl,
                  )}`}
                  className="w-full h-full  border-0"
                  title={previewFile.name}
                />
        // <div style={{ padding: '20px', maxHeight: '70vh', overflow: 'auto', width: '100%', transform: `scale(${zoomLevel})`,
        //       transformOrigin: 'top left',
        //       transition: 'transform 0.2s ease'}}>
        //   <div 
        //     dangerouslySetInnerHTML={{ __html: textContent }}
        //   />
        // </div>
      );
    }
    
    // PDF files - Using pdfjs-dist (canvas rendering)
// if (previewFile.type === 'application/pdf') {
//   return (
//     <div style={{ 
//       padding: '20px', 
//       width: '100%', 
//       maxHeight: '70vh',
//       overflow: 'auto',
//       display: 'flex',
//       flexDirection: 'column',
//       alignItems: 'flex-start',
//       backgroundColor: '#f3f4f6'
//     }}>
//       <div style={{ 
//         display: 'inline-block',  // ✅ Wraps around canvas natural size
//         boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
//         backgroundColor: 'white'
//       }}>
//     <canvas
//         ref={canvasRef}
//         style={{
//           // width: 'auto',
//           height: 'auto',
//           boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
//           backgroundColor: 'white',
//           display: 'block',
//         }}
//       />
// </div>

//       {/* Page Navigation */}
    
// {pdfNumPages > 1 && (
//   <div style={{
//     marginTop: '20px',
//     display: 'inline-flex',
//     alignItems: 'center',
//     gap: '4px',
//     padding: '4px',
//     backgroundColor: 'lightgray',
//     borderRadius: '8px',
//     boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
//     alignSelf: 'center'  // Centers the navigation
//   }}>
//     {/* Previous Button */}
//     <button
//       onClick={() => setPdfPageNum(prev => Math.max(prev - 1, 1))}
//       disabled={pdfPageNum <= 1}
//       onMouseEnter={(e) => {
//         if (pdfPageNum > 1) {
//           e.currentTarget.style.backgroundColor = '#e5e7eb';
//         }
//       }}
//       onMouseLeave={(e) => {
//         e.currentTarget.style.backgroundColor = 'transparent';
//       }}
//       style={{
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         width: '20px',
//         height: '20px',
//         backgroundColor: 'transparent',
//         color: pdfPageNum <= 1 ? '#d1d5db' : '#4b5563',
//         border: 'none',
//         borderRadius: '6px',
//         cursor: pdfPageNum <= 1 ? 'not-allowed' : 'pointer',
//         transition: 'all 0.2s',
//         fontSize: '14px'
//       }}
//       title="Previous page"
//     >
//       <FaChevronLeft />
//     </button>

//     {/* Page Counter */}
//     <div style={{
//       display: 'flex',
//       alignItems: 'center',
//       padding: '0 12px',
//       minWidth: '65px',
//       justifyContent: 'center'
//     }}>
//       <span style={{
//         fontSize: '13px',
//         fontWeight: '500',
//         color: '#374151',
//         whiteSpace: 'nowrap'
//       }}>
//         {pdfPageNum} / {pdfNumPages}
//       </span>
//     </div>

//     {/* Next Button */}
//     <button
//       onClick={() => setPdfPageNum(prev => Math.min(prev + 1, pdfNumPages))}
//       disabled={pdfPageNum >= pdfNumPages}
//       onMouseEnter={(e) => {
//         if (pdfPageNum < pdfNumPages) {
//           e.currentTarget.style.backgroundColor = '#e5e7eb';
//         }
//       }}
//       onMouseLeave={(e) => {
//         e.currentTarget.style.backgroundColor = 'transparent';
//       }}
//       style={{
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         width: '20px',
//         height: '20px',
//         backgroundColor: 'transparent',
//         color: pdfPageNum >= pdfNumPages ? '#d1d5db' : '#4b5563',
//         border: 'none',
//         borderRadius: '6px',
//         cursor: pdfPageNum >= pdfNumPages ? 'not-allowed' : 'pointer',
//         transition: 'all 0.2s',
//         fontSize: '14px'
//       }}
//       title="Next page"
//     >
//       <FaChevronRight />
//     </button>
//   </div>
// )}
//     </div>
//   );
// }

    if (previewFile.type === 'application/pdf') {
      const previewUrl =  previewFile?.serverUrl || previewFile?.url;
      // Blob/data URLs are rendered by the browser's built-in PDF viewer.
      if (isLocalUrl(previewUrl)) {
        return (
          <div className="w-full h-full">
            <iframe
              src={previewUrl}
              title={previewFile.name}
              style={{
                width: '100%',
                height: '100%',
                minHeight: '500px',
                border: 'none',
                backgroundColor: '#f3f4f6',
              }}
              onLoad={() => setIsLoadingPreview(false)}
            />
          </div>
        );
      }
      return (
        <div className="w-full h-full">
          {/* <iframe
            src={previewFile.url}
            title={previewFile.name}
            style={{
              width: '100%',
              height: '100%',
              border: 'none',
              backgroundColor: '#f3f4f6',
            }}
          /> */}
          <iframe
                  src={`https://docs.google.com/gview?url=${encodeURIComponent(
                    previewUrl,
                  )}&embedded=true`}
                  className="w-full h-full min-h-[500px] border-0"
                  title={previewFile.name}
                />
        </div>
      );
    }


    // Audio files
    if (previewFile.type.startsWith('audio/')) {
      return (
        <div style={{ padding: '40px', textAlign: 'center', width: "100%" }}>
          <MusicIcon />
          <audio controls style={{ width: '100%', marginTop: '20px' }}>
            <source src={previewFile.url} type={previewFile.type} />
            Your browser does not support the audio element.
          </audio>
        </div>
      );
    }
    
    // // Video files
    // if (previewFile.type.startsWith('video/')) {
    //   return (
    //     <video 
    //       controls 
    //       style={{ maxWidth: '100%', maxHeight: '70vh' }}
    //     >
    //       <source src={previewFile.url} type={previewFile.type} />
    //       Your browser does not support the video element.
    //     </video>
    //   );
    // }
    
    // Text files
    if (previewFile.type === 'text/plain') {
      return (
        <div style={{ padding: '20px', maxHeight: '70vh', overflow: 'auto' }}>
          <pre style={{ whiteSpace: 'pre-wrap', fontFamily: 'monospace', transform: `scale(${zoomLevel})`,
            transformOrigin: 'top left',
            transition: 'transform 0.2s ease'}}>
            {textContent}
          </pre>
        </div>
      );
    }
    
    // Default fallback for unsupported file types
    return renderUnsupportedFallback();
  };

  const modalContent = (
    <div className="file-preview-backdrop" onClick={handleClose}>
      <div>
         <div className="file-preview-header">
           <div className="file-preview-fileclose">
           <button 
          className='close-preview-button'
          onClick={handleClose}
        >
          <div style={{ width: '18px', color: '#fff' }}>
            <XIcon />
          </div>
        </button>

            <div className="file-preview-file-info">
              <div className="file-preview-icon">
                {getFileIcon(previewFile.type, previewFile.name)}
              </div>
              <h3 className="file-preview-filename">
                {previewFile?.name}
              </h3>
            </div>
           </div>
           
            
             {previewFile && !previewFile.type.startsWith('audio/') && (
            <a 
          href={previewFile.url} 
          download={previewFile.name}
          style={{ 
            padding: '8px 10px',
            backgroundColor: '#fff',
            borderRadius: '50%'
          }}
        >
          <img src={download} alt="Download" />
        </a>
             )}
          </div>
           {/* Previous button */}
        {files.length > 1 && (
          <button 
            className='file-preview-nav-button file-preview-prev-button'
            onClick={handlePrevious}
            disabled={currentIndex === 0}
          >
            <svg style={{ width: '20px', height: '20px', color: '#333' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
        )}

        {/* Next button */}
        {files.length > 1 && (
          <button 
            className='file-preview-nav-button file-preview-next-button'
            onClick={handleNext}
            disabled={currentIndex === files.length - 1}
          >
            <svg style={{ width: '20px', height: '20px', color: '#333' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>
        )}
      </div>
      <div className="file-preview-container" onClick={(e) => e.stopPropagation()}>

        {/* Modal content */}
        <div className={`file-preview-modal ${previewFile?.type?.startsWith('audio/') ? 'audio-preview' : ''}`}>    
          {/* Preview content */}
            <div className="file-preview-content">
              {renderPreviewContent()}
              
              {/* Loading overlay */}
              {isLoadingPreview && (
                <div>
                  <LoaderComponent />
                </div>
              )}
            </div>

          {/* <div className="file-preview-zoom-controls" style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center',
            padding: '15px',
            borderTop: '1px solid #e5e7eb'
          }}>
             {previewFile && !previewFile.type.startsWith('audio/') && (
            <div className="zoom-control-button"
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                padding: isZoomExpanded ? '8px 16px' : '12px',
                backgroundColor: 'white',
                borderRadius: '50px',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                width: isZoomExpanded ? 'auto' : '48px',
                height: '48px',
                justifyContent: 'center'
              }}
              onClick={() => !isZoomExpanded && setIsZoomExpanded(true)}
            >
              <div className="zoom-control-icon" style={{ 
                display: 'flex', 
                alignItems: 'center',
                fontSize: '18px',
                color: '#333'
              }}>
                <FaSearchPlus />
              </div>

              {isZoomExpanded && (
                <>
                  <span className="zoom-control-percentage" style={{ 
                    fontSize: '14px', 
                    fontWeight: '600',
                    minWidth: '45px',
                    textAlign: 'center',
                    color: '#333',
                    userSelect: 'none'
                  }}>
                    {Math.round(zoomLevel * 100)}%
                  </span>

                  <button className="zoom-control-button"
                    onClick={(e) => {
                      e.stopPropagation();
                      zoomOut();
                    }}
                    disabled={zoomLevel <= 0.5}
                    style={{ 
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '32px',
                      height: '32px',
                      fontSize: '16px',
                      backgroundColor: 'transparent',
                      color: zoomLevel <= 0.5 ? '#9ca3af' : '#333',
                      border: 'none',
                      borderRadius: '50%',
                      cursor: zoomLevel <= 0.5 ? 'not-allowed' : 'pointer',
                      fontWeight: '700',
                      transition: 'all 0.2s ease'
                    }}
                    title="Zoom Out"
                  >
                    −
                  </button>

                  <button className="zoom-control-button"
                    onClick={(e) => {
                      e.stopPropagation();
                      zoomIn();
                    }}
                    disabled={zoomLevel >= 3}
                    style={{ 
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '32px',
                      height: '32px',
                      fontSize: '20px',
                      backgroundColor: 'transparent',
                      color: zoomLevel >= 3 ? '#9ca3af' : '#333',
                      border: 'none',
                      borderRadius: '50%',
                      cursor: zoomLevel >= 3 ? 'not-allowed' : 'pointer',
                      fontWeight: '400',
                      transition: 'all 0.2s ease'
                    }}
                    title="Zoom In"
                  >
                    +
                  </button>
                </>
              )}
            </div>
            )}
          </div> */}

        </div>
      </div>
    </div>
  );

  // Use portal to render at root level
  return createPortal(modalContent, document.body);
}